import React from "react";
const Table = ({ yearlySalesData }) => {
  return (
    <table
      style={{
        width: "100%",
        borderCollapse: "collapse",
        border: "1px solid #ddd",
        fontFamily: "Karla",
      }}
    >
      <thead
        style={{
          textAlign: "left",
        }}
      >
        <tr>
          <th style={{ padding: "10px", border: "1px solid black", fontSize: "18px", fontWeight: 400, textAlign: "center" }}>Year</th>
          <th style={{ padding: "10px", border: "1px solid black", fontSize: "18px", fontWeight: 400, textAlign: "center" }}>Sales</th>
        </tr>
      </thead>
      <tbody>
        {yearlySalesData && yearlySalesData.length > 0 ? (
          yearlySalesData.map((item) => (
            <tr key={item?.year} style={{ borderBottom: "1px solid black" }}>
              <td style={{ padding: "10px", border: "1px solid black", textAlign: "center" }}>{item?.year}</td>
              <td style={{ padding: "10px", border: "1px solid black", textAlign: "center" }}>{item?.totalSale}</td>
            </tr>
          ))
        ) : (
          <tr>
            <td
              colSpan="2"
              style={{
                padding: "10px",
                textAlign: "center",
                border: "1px solid black",
                color: "#888",
              }}
            >
              No sales data available.
            </td>
          </tr>
        )}
      </tbody>
    </table>
  );
};
export default Table;
